/**
 * Propally Agent API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';

/**
 * The FirstRegistrationRequest model module.
 * @module model/FirstRegistrationRequest
 * @version 1.0.0
 */
class FirstRegistrationRequest {
    /**
     * Constructs a new <code>FirstRegistrationRequest</code>.
     * @alias module:model/FirstRegistrationRequest
     * @param familyName {String} 
     * @param firstName {String} 
     * @param phoneNumber {String} 
     * @param email {String} 
     * @param password {String} 
     * @param passwordConfirmation {String} 
     * @param companyName {String} 申告企業名。承認時に Admin が企業を選ぶ材料
     */
    constructor(familyName, firstName, phoneNumber, email, password, passwordConfirmation, companyName) { 
        
        FirstRegistrationRequest.initialize(this, familyName, firstName, phoneNumber, email, password, passwordConfirmation, companyName);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj, familyName, firstName, phoneNumber, email, password, passwordConfirmation, companyName) { 
        obj['family_name'] = familyName;
        obj['first_name'] = firstName;
        obj['phone_number'] = phoneNumber;
        obj['email'] = email;
        obj['password'] = password;
        obj['password_confirmation'] = passwordConfirmation;
        obj['company_name'] = companyName;
    }

    /**
     * Constructs a <code>FirstRegistrationRequest</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/FirstRegistrationRequest} obj Optional instance to populate.
     * @return {module:model/FirstRegistrationRequest} The populated <code>FirstRegistrationRequest</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new FirstRegistrationRequest();

            if (data.hasOwnProperty('family_name')) {
                obj['family_name'] = ApiClient.convertToType(data['family_name'], 'String');
            }
            if (data.hasOwnProperty('first_name')) {
                obj['first_name'] = ApiClient.convertToType(data['first_name'], 'String');
            }
            if (data.hasOwnProperty('phone_number')) {
                obj['phone_number'] = ApiClient.convertToType(data['phone_number'], 'String');
            }
            if (data.hasOwnProperty('email')) {
                obj['email'] = ApiClient.convertToType(data['email'], 'String');
            }
            if (data.hasOwnProperty('password')) {
                obj['password'] = ApiClient.convertToType(data['password'], 'String');
            }
            if (data.hasOwnProperty('password_confirmation')) {
                obj['password_confirmation'] = ApiClient.convertToType(data['password_confirmation'], 'String');
            }
            if (data.hasOwnProperty('company_name')) {
                obj['company_name'] = ApiClient.convertToType(data['company_name'], 'String');
            }
        }
        return obj;
    }

    /**
     * Validates the JSON data with respect to <code>FirstRegistrationRequest</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>FirstRegistrationRequest</code>.
     */
    static validateJSON(data) {
        // check to make sure all required properties are present in the JSON string
        for (const property of FirstRegistrationRequest.RequiredProperties) {
            if (!data[property]) {
                throw new Error("The required field `" + property + "` is not found in the JSON data: " + JSON.stringify(data));
            }
        }
        // ensure the json data is a string
        if (data['family_name'] && !(typeof data['family_name'] === 'string' || data['family_name'] instanceof String)) {
            throw new Error("Expected the field `family_name` to be a primitive type in the JSON string but got " + data['family_name']);
        }
        // ensure the json data is a string
        if (data['first_name'] && !(typeof data['first_name'] === 'string' || data['first_name'] instanceof String)) {
            throw new Error("Expected the field `first_name` to be a primitive type in the JSON string but got " + data['first_name']);
        }
        // ensure the json data is a string
        if (data['phone_number'] && !(typeof data['phone_number'] === 'string' || data['phone_number'] instanceof String)) {
            throw new Error("Expected the field `phone_number` to be a primitive type in the JSON string but got " + data['phone_number']);
        }
        // ensure the json data is a string
        if (data['email'] && !(typeof data['email'] === 'string' || data['email'] instanceof String)) {
            throw new Error("Expected the field `email` to be a primitive type in the JSON string but got " + data['email']);
        }
        // ensure the json data is a string
        if (data['password'] && !(typeof data['password'] === 'string' || data['password'] instanceof String)) {
            throw new Error("Expected the field `password` to be a primitive type in the JSON string but got " + data['password']);
        }
        // ensure the json data is a string
        if (data['password_confirmation'] && !(typeof data['password_confirmation'] === 'string' || data['password_confirmation'] instanceof String)) {
            throw new Error("Expected the field `password_confirmation` to be a primitive type in the JSON string but got " + data['password_confirmation']);
        }
        // ensure the json data is a string
        if (data['company_name'] && !(typeof data['company_name'] === 'string' || data['company_name'] instanceof String)) {
            throw new Error("Expected the field `company_name` to be a primitive type in the JSON string but got " + data['company_name']);
        }

        return true;
    }


}

FirstRegistrationRequest.RequiredProperties = ["family_name", "first_name", "phone_number", "email", "password", "password_confirmation", "company_name"];

/**
 * @member {String} family_name
 */
FirstRegistrationRequest.prototype['family_name'] = undefined;

/**
 * @member {String} first_name
 */
FirstRegistrationRequest.prototype['first_name'] = undefined;

/**
 * @member {String} phone_number
 */
FirstRegistrationRequest.prototype['phone_number'] = undefined;

/**
 * @member {String} email
 */
FirstRegistrationRequest.prototype['email'] = undefined;

/**
 * @member {String} password
 */
FirstRegistrationRequest.prototype['password'] = undefined;

/**
 * @member {String} password_confirmation
 */
FirstRegistrationRequest.prototype['password_confirmation'] = undefined;

/**
 * 申告企業名。承認時に Admin が企業を選ぶ材料
 * @member {String} company_name
 */
FirstRegistrationRequest.prototype['company_name'] = undefined;






export default FirstRegistrationRequest;

